export default class StaticInfo
{
  constructor(titles, tabs, image, documents)
  {
    this.titles = titles; // {} instead of array to support stringify
    this.tabs = tabs;
    this.image = image;
    this.documents = documents || [];
  }

  isValid()
  {
    var result = this.tabs && Array.isArray(this.tabs) && this.tabs.length;

    if(result)
    {
      // Titles
      for (const [key, value] of Object.entries(this.titles)) {
        if(!value)
        {
          result = false;
          break;
        };
      }
    }

    return result;
  }
}